import { DefaultSkillMapTarget } from '../../../_generated/graphql'
import { SkillMap } from './assessment.mapping'

export function resolveInitialSkillMap(
  skillMaps: SkillMap[],
  target: DefaultSkillMapTarget,
): SkillMap | null {
  return (
    skillMaps.find((map) => map.defaultTargets.includes(target)) ??
    skillMaps.reduce<SkillMap | null>(
      (latest, map) =>
        !latest || map.createdAt.getTime() > latest.createdAt.getTime()
          ? map
          : latest,
      null,
    )
  )
}
